import { Auth } from "aws-amplify";
import axios from "axios";

const ACS_API_BASE_URL = process.env.MAIN_API;

class ClientNotificationService {
  async geNotificationList() {
    let myInit = {
      params: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };

    return await axios.get(
      ACS_API_BASE_URL + "/external-notification/get_data",
      myInit
    );
  }

  async createExternalNotification(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    // Use the absolute URL as requested
    return await axios.post(
      ACS_API_BASE_URL + `/external-notification/create_external_notification`,
      payload,
      myInit
    );
  }

  async editExternalNotification(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    // Use the absolute URL as requested
    return await axios.post(
      ACS_API_BASE_URL + `/external-notification/edit_external_notification`,
      payload,
      myInit
    );
  }

  async deleteExternalNotification(payload) {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    };
    // Use the absolute URL as requested
    return await axios.post(
      ACS_API_BASE_URL + "/external-notification/delete_external_notification",
      payload,
      myInit
    );
  }
}

export default new ClientNotificationService();
